import { useApiList } from "@/queries/base/useApiList";

/**
 * Fetches all Part Usages.
 * GET /part_usage
 */
export function usePartUsages(deps = []) {
  return useApiList("/part_usage", [deps]);
}
